import { IconEyeOutline18 as Eye } from "nucleo-ui-outline-18"

import { useSession } from "@/lib/session"

export function ViewAccessWarning() {
	const { session } = useSession()

	if (session?.membershipRole !== "VIEWER") {
		return null
	}

	return (
		<div className="mx-4 mb-4 flex select-none flex-col gap-3 rounded-lg border bg-gray-100 px-3 py-4 shadow-md dark:bg-gray-850">
			<div className="flex flex-row items-center gap-1 text-xs font-medium">
				<Eye className="mr-1 h-4 w-4 stroke-green-500" />
				View access
			</div>
			<div className="mb-1 text-xxs font-normal text-secondary">
				You&apos;re a viewer. Please contact your admin to get access or get in
				touch with our support.
			</div>
		</div>
	)
}
